(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgb-hero-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Splide('#hero-slider', {
    type: 'loop',           // Infinite loop
    autoplay: true,         // Auto slide
    interval: 5000,         // Interval between slides
    pauseOnHover: false,    // Auto continue on hover
    arrows: true,           // Navigation arrows
    pagination: false,      // Disable pagination (dots)
    perPage: 1,             // Show one slide at a time
    perMove: 1,             // Move one slide at a time
    breakpoints: {
      768: {
        arrows: true,
        pagination: true,   // Enable pagination on smaller screens
        perPage: 1,         // Show one slide at a time on mobile
      },
    },
  }).mount();
});

  } catch(e) { console.error(e); }
})();
})();
